import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.span`
	font-weight: 500;
	font-family: ${helpers.font.family.header};
	font-size: ${helpers.font.size.h5};
	color: ${helpers.color.textHeader};
`
